import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPlans } from '../services/api'; // Use your API file

export const getPlans = createAsyncThunk('plans/getPlans', async () => {
    const response = await fetchPlans(); // Pass reviewId if available
    return response.data;
});

const planSlice = createSlice({
    name: 'plans',
    initialState: {
        plans: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getPlans.pending]: (state) => {
            state.status = 'loading';
        },
        [getPlans.fulfilled]: (state, action) => {
            state.plans = action.payload.data;
            state.status = 'succeeded';
        },
        [getPlans.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default planSlice.reducer;